export const AFFIRMATIONS = [
  "I am still here, and that is quietly heroic.",
  "This feeling is a visitor, not a resident.",
  "Stars need darkness to be seen — so does my own light.",
  "I can do hard things one gentle breath at a time.",
  "My story is not finished; this is only a chapter.",
  "I am worthy of care, especially from myself.",
  "Healing is not linear, and I am allowed to begin again.",
  "The dawn has never once failed to arrive.",
  "I release what I cannot carry today.",
  "My presence in this world matters more than I know.",
  "I do not have to solve my whole life today. I only need to make it through this moment.",
  "Feeling overwhelmed does not make me weak. It means I have been carrying a lot.",
  "I will ask for help before things get worse.",
  "It is okay not to feel okay, but it is not okay to stay this way.",
  "I can give myself permission to stay.",
  "I do not need to have all the answers to deserve another day.",
  "I can pause, breathe, and take the next small step.",
  "My pain deserves care, not punishment.",
  "I am allowed to rest without giving up on myself.",
  "I can reach for someone when being alone feels too heavy.",
  "I am more than the hardest thing I am feeling right now.",
  "I do not have to believe every painful thought that enters my mind.",
  "There is no shame in needing support.",
  "I choose to stay and be guided by my future.",
  "I will put the past behind me. My future is bright.",
];

export const STORIES = [
  {
    id: "maya",
    name: "Maya, 34",
    tag: "Depression & Recovery",
    excerpt:
      "There was a winter when getting out of bed felt like climbing a mountain. 988 answered at 2am when I had no words left. Two years on, I plant a garden every spring — proof that roots can hold on through the dark.",
    quote: "I stayed. And staying became a garden.",
  },
  {
    id: "andre",
    name: "André, 22",
    tag: "LGBTQ+",
    excerpt:
      "When my family didn't understand, The Trevor Project did. A kind voice reminded me that who I am is not a mistake. Today I mentor other young people learning to love themselves out loud.",
    quote: "Someone believed in me until I could.",
  },
  {
    id: "jordan",
    name: "Jordan, 16",
    tag: "Teens",
    excerpt:
      "Sophomore year, everything felt too loud and too much — grades, group chats, the pressure to be okay. Texting a teen helpline at midnight, I learned I wasn't weak for struggling. I just needed someone my age to say 'me too.'",
    quote: "I wasn't weak for struggling — I was human.",
  },
  {
    id: "dcohen",
    name: "Dr. Cohen",
    tag: "Grief & Loss",
    excerpt:
      "After losing my brother, guilt nearly swallowed me. Writing his story — and mine — in community helped me breathe again. Grief didn't shrink; I grew around it, and found purpose in accompaniment.",
    quote: "I grew around the loss until I could breathe.",
  },
  {
    id: "priya",
    name: "Priya, 41",
    tag: "Postpartum",
    excerpt:
      "The sanctuary sounds got me through the longest nights of postpartum depression. One breath, one song, one sunrise. I am not the shadow that visited me — I am the mother who kept singing.",
    quote: "One breath, one song, one sunrise.",
  },
];

export const RESOURCE_GROUPS = [
  {
    category: "Immediate Crisis",
    items: [
      { name: "988 Suicide & Crisis Lifeline", detail: "Call or Text 988 · 24/7 · US & Canada", action: "tel:988", cta: "Call 988" },
      { name: "Crisis Text Line", detail: "Text HOME to 741741 · Trained counselors", action: "sms:741741", cta: "Text HOME" },
    ],
  },
  {
    category: "LGBTQ+",
    items: [
      { name: "The Trevor Project", detail: "Call 1-866-488-7386 · Text START to 678-678 · Affirming, judgment-free support for LGBTQ+ young people", action: "tel:18664887386", cta: "Call Trevor" },
      { name: "LGBT National Youth Talkline", detail: "Call 1-800-246-7743 · Confidential peer support by & for the LGBTQ+ community", action: "tel:18002467743", cta: "Call Talkline" },
      { name: "Trans Lifeline", detail: "Call 1-877-565-8860 · Peer support run by and for trans people", action: "tel:18775658860", cta: "Call Lifeline" },
    ],
  },
  {
    category: "Teens",
    items: [
      { name: "Teen Line", detail: "Text TEEN to 839863 · Call 1-800-852-8336 · Teens helping teens, every evening", action: "sms:839863", cta: "Text TEEN" },
      { name: "Your Life Your Voice", detail: "Call 1-800-448-3000 · Text VOICE to 20121 · Free support for teens & young adults", action: "tel:18004483000", cta: "Call Now" },
    ],
  },
  {
    category: "Veterans & Families",
    items: [
      { name: "Veterans Crisis Line", detail: "Dial 988, Press 1 · Text 838255", action: "tel:988", cta: "Dial 988 · 1" },
    ],
  },
  {
    category: "Specialized Support",
    items: [
      { name: "Postpartum Support Intl.", detail: "Call 1-800-944-4773 · Parents & families", action: "tel:18009444773", cta: "Call PSI" },
      { name: "SAMHSA National Helpline", detail: "Substance Abuse & Mental Health Services Administration · 1-800-662-4357 · Free, confidential treatment referral & info, 24/7", action: "tel:18006624357", cta: "Call SAMHSA" },
      { name: "Findahelpline (Worldwide)", detail: "70+ verified international helplines", action: "https://www.findahelpline.com/", cta: "Find Yours", external: true },
      { name: "Befrienders Worldwide", detail: "A global network of emotional-support centres, so you can find a caring, confidential listener in your own country and language", action: "https://www.befrienders.org/", cta: "Find a Centre", external: true },
    ],
  },
  {
    category: "Addictions",
    items: [
      { name: "Gamblers Anonymous", detail: "Free, confidential fellowship meetings, in person and online, for anyone who wants to stop gambling and rebuild their life", action: "https://www.gamblersanonymous.org/", cta: "Find a Meeting", external: true },
      { name: "Alcoholics Anonymous", detail: "Free, confidential meetings worldwide, in person and online, for anyone who wants to stop drinking, one day at a time", action: "https://www.aa.org/", cta: "Find a Meeting", external: true },
      { name: "Narcotics Anonymous", detail: "A supportive fellowship of people helping each other recover from drug addiction, with free meetings around the world", action: "https://na.org/", cta: "Find a Meeting", external: true },
      { name: "Al-Anon Family Groups", detail: "Hope and support for families and friends affected by someone else's drinking, including Alateen for young people", action: "https://al-anon.org/", cta: "Find a Meeting", external: true },
    ],
  },
];

export const FAQ = [
  { q: "Is Bright Stories Network a crisis hotline?", a: "No. We are a supportive community resource. For immediate crisis support please call or text 988, or 911 if you are in danger. We make trusted lines visible on every page." },
  { q: "Are my downloads and donations private?", a: "Yes. We practice strict, privacy-first confidentiality. We do not sell personal data, and payments are processed securely by Stripe." },
  { q: "Can I share my own survivor story?", a: "Absolutely. Visit Survivor Stories and use the gentle submission portal. You choose whether your words are shared publicly." },
  { q: "How are donations used?", a: "Gifts fund free crisis resources, the Calming Media Sanctuary, printable Super Kids materials, and survivor audio recordings." },
];

export const PRAYERS = [
  {
    id: "peace",
    title: "A Prayer for Peace of Mind",
    by: "Shared by our founder",
    videoUrl: "",
    text: "May the storm inside you grow quiet. May you feel, even for a moment, that you are held, that you are loved, and that you do not have to carry this alone. Rest here a while. You are safe. You are enough. And tomorrow is still yours.",
  },
  {
    id: "courage",
    title: "A Blessing for the Weary",
    by: "Shared by our founder",
    videoUrl: "",
    text: "For the one who is tired down to the bone: may you find the courage to stay one more day, and then one more. May help find you, and may you let it in. You are braver than this heavy moment, and your story is far from over.",
  },
];
